/* ============================================================
   BOTANILABS — Predictive search overlay behaviour.
   Open/close + empty-state shortcuts. The actual predictive
   fetching is Dawn's native <predictive-search> (search-form.js +
   predictive-search.js); here we only manage the overlay chrome
   and the visitor's recent-search history (localStorage).
   Loaded via <script defer> from snippets/botani-search.liquid.
   ============================================================ */
(function () {
  var STORE_KEY = 'botani_recent_searches';
  var MAX_RECENT = 6;
  var MIN_LEN = 2;

  function getRecent() {
    try {
      var arr = JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function addRecent(term) {
    if (!term) return;
    term = term.trim();
    if (term.length < MIN_LEN) return;
    var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    list = list.slice(0, MAX_RECENT);
    try { localStorage.setItem(STORE_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function clearRecent() {
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
  }
  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    var overlay = document.getElementById('BotaniSearch');
    if (!overlay || overlay.dataset.bsbound) return;
    overlay.dataset.bsbound = '1';

    var input = overlay.querySelector('#BotaniSearchInput');
    var form = overlay.querySelector('form');
    var popBlock = overlay.querySelector('[data-bsearch-pop]');
    var popLabel = overlay.querySelector('[data-bsearch-pop-label]');
    var popTags = overlay.querySelector('[data-bsearch-pop-tags]');

    // Cache the editor-driven "popular" fallback so we can restore it when there's no history.
    var fallbackLabel = popLabel ? popLabel.innerHTML : '';
    var fallbackTags = popTags ? popTags.innerHTML : '';

    var CLOCK_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 8l0 4l2 2"/><path d="M3.05 11a9 9 0 1 0 .5 -4m-.5 -5v5h5"/></svg>';

    function renderPop() {
      if (!popBlock || !popLabel || !popTags) return;
      var recent = getRecent();
      if (recent.length) {
        popLabel.innerHTML =
          '<span class="bsearch-blabel-main">' + CLOCK_SVG + ' Recherches récentes</span>' +
          '<button type="button" class="bsearch-clear-recent" data-bsearch-clear-recent>Effacer</button>';
        popTags.innerHTML = recent.map(function (t) {
          var safe = escapeHtml(t);
          return '<button type="button" class="bsearch-tag" data-bsearch-term="' + safe + '">' + safe + '</button>';
        }).join('');
      } else {
        popLabel.innerHTML = fallbackLabel;
        popTags.innerHTML = fallbackTags;
      }
    }

    function open() {
      // Close the nav drawer if it happens to be open (shared with the burger search field).
      var nav = document.getElementById('BotaniMenuDrawer');
      if (nav && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        var navOverlay = document.getElementById('BotaniMenuOverlay');
        if (navOverlay) navOverlay.classList.remove('is-open');
      }
      renderPop();
      overlay.classList.add('bsearch--open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 120);
    }
    function close() {
      overlay.classList.remove('bsearch--open');
      document.body.style.overflow = '';
      // Reset everything so the next open always starts fresh (empty field + initial state).
      if (input) input.value = '';
      overlay.removeAttribute('open');
      overlay.removeAttribute('loading');
      overlay.removeAttribute('results');
      var resultsBox = overlay.querySelector('[data-predictive-search]');
      if (resultsBox) resultsBox.innerHTML = '';
      var clearBtn = overlay.querySelector('.bsearch-clear');
      if (clearBtn) clearBtn.classList.add('hidden');
    }
    window.BotaniSearch = { open: open, close: close };

    // Triggers (header icon, drawer field) + close zones — delegated so they survive re-renders.
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-bsearch-open]');
      if (opener) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-bsearch-close]')) { close(); }
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('bsearch--open')) close();
    });

    // Overlay-scoped clicks: tags, clear history, and recording on result/view-all links.
    overlay.addEventListener('click', function (e) {
      var clearBtn = e.target.closest('[data-bsearch-clear-recent]');
      if (clearBtn) { clearRecent(); renderPop(); if (input) input.focus(); return; }

      var tag = e.target.closest('[data-bsearch-term]');
      if (tag) {
        if (!input) return;
        input.value = tag.getAttribute('data-bsearch-term');
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
        return;
      }

      // A product result or "voir tous les résultats" was clicked → remember the query.
      if (e.target.closest('.bresult, .bsearch-viewall')) {
        if (input) addRecent(input.value);
      }
    });

    // Submitting the form (Enter / search) also records the term.
    if (form) {
      form.addEventListener('submit', function () { if (input) addRecent(input.value); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
